import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { PermissionCheckerService } from 'abp-ng2-module';

import { AppSessionService } from '../session/app-session.service';

@Injectable()
export class AppRouteGuard implements CanActivate, CanActivateChild {

    horizontalPosition: MatSnackBarHorizontalPosition = 'center';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    constructor(
        private _permissionChecker: PermissionCheckerService,
        private _router: Router,
        private _sessionService: AppSessionService,
        private _snackBar: MatSnackBar
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        if (!this._sessionService.user) {
            this._router.navigate(['/account/login']);
            return false;
        }

        if (!route.data || !route.data['permission']) {
            return true;
        }

        if (this._permissionChecker.isGranted(route.data['permission'])) {
            return true;
        }
        else {

            let snackBarRef = this._snackBar.open("Bu sayfaya girme yetkiniz yoktur. Ana sayfaya yönlediriliyorsunuz.", "Kapat", {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
            });
            snackBarRef.afterDismissed().subscribe(() => {
                this._router.navigate([this.selectBestRoute()]);
                return false;
            })
            //this.toastr.error("Bu sayfaya girme yetkiniz yoktur. Ana sayfaya yönlediriliyorsunuz.");

        }

    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    selectBestRoute(): string {
        if (!this._sessionService.user) {
            return '/account/login';
        }

        // if (this._permissionChecker.isGranted('Pages.Users')) {
        //     return '/app/admin/users';
        // }

        return 'app/dashboard/v5';
    }
}
